import { Component, Inject, NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { combineLatest, of, map } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HtmlEditorModule } from '../html-editor/html-editor.component';


@Component({
    selector: 'uw-edit-faq-dialog',
    standalone: false,
    templateUrl: './edit-faq-dialog.component.html',
    styleUrls: ['./edit-faq-dialog.component.scss']
})
export class EditFaqDialogComponent {

  readonly form: UntypedFormGroup = new UntypedFormGroup({
    question: new UntypedFormControl(null, [Validators.required]),
    answer: new UntypedFormControl(null, [Validators.required])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) _faq: any,
    private readonly _dialogRef: MatDialogRef<EditFaqDialogComponent>
  ) {
    if (_faq) {
      this.form.patchValue(_faq, { emitEvent: false });
    }
  }

  handleSave(faq: any) {
    this._dialogRef.close(faq);
  }
}

@NgModule({
    declarations: [
        EditFaqDialogComponent
    ],
    exports: [
        EditFaqDialogComponent
    ],
    imports: [
        A11yModule,
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        ReactiveFormsModule,
        HtmlEditorModule
    ]
})
export class CreateFaqDialogModule { }
